import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpbjf9vqr6/layouts/custom.vue").then(m => m.default || m))
}